<template>
    <section class="chart-container" >
        <div class=" ml30 mr30" >

            <!--拒绝弹窗界面1  "-->
            <el-dialog title="拒绝理由" v-model="show_refuse" width="55%" :close-on-click-modal="true" :visible.sync="show_refuse" append-to-body="true">
                <el-input type="textarea" :rows="3" placeholder="请输入内容" style="width:100%;" v-model="refuse_reason"></el-input>
                <div class="row flex-center mt25"><el-button class="set-other-btn " style="width:343px;" @click.native="sure_refuse">确认拒绝</el-button></div>
            </el-dialog>





<!--            <div >-->
<!--                <div class="row flex-start">-->
<!--                    <div class="row flex-start"><div>场地名称：</div>-->
<!--                        <el-select ref="selectValue1" v-model="optionValue" filterable placeholder="请选择" class="mr45">-->
<!--                            <el-option-->
<!--                                    v-for="item in optionList"-->
<!--                                    :key="item.value"-->
<!--                                    :label="item.label"-->
<!--                                    :value="item.value"-->
<!--                            />-->
<!--                        </el-select>-->
<!--                    </div>-->
<!--                    <div style="width:132px;height:36px;box-shadow: 0px 1px 4px 0px #798B95;" class="fontwb font12 row flex-center mr15 cursorp" :class="active2==0?'yellow_bg':'white_bg'" @click="onTab2(0)">待审核{{totalA}}条</div>-->
<!--                    <div style="width:132px;height:36px;box-shadow: 0px 1px 4px 0px #798B95;" class="fontwb font12 row flex-center mr15 cursorp"  :class="active2==1?'green_bg':'white_bg'" @click="onTab2(1)">审核通过{{totalB}}条</div>-->
<!--                    <div style="width:132px;height:36px;box-shadow: 0px 1px 4px 0px #798B95;" class="fontwb font12 row flex-center mr15 cursorp"  :class="active2==2?'red_bg':'white_bg'" @click="onTab2(2)">未通过{{totalC}}条</div>-->

<!--                <div class="mr15 row flex-center ml15" style="width:300px;">-->
<!--                   <div style="width:110px;">关键字搜索:</div>-->
<!--                    <el-input-->
<!--                            placeholder="搜索关键字"-->
<!--                            v-model="keywords">-->
<!--                    </el-input>-->
<!--                </div>-->

<!--                    <div class="row flex-center ml5 mr15"><el-button class="set-other-btn " style="width:73px; height:38px;" @click.native="editAutoAuditConfig">确定</el-button></div>-->
<!--                    <div class="row flex-center grey6_text mr5 ml5" @click="editAutoAuditConfig2()" ><img class="mr5" :src="checked?require('../../static/img/yes01.svg'):require('../../static/img/no01_hq.png')" style="width:18px;height:18px;" />自动审核</div>-->

<!--                    <el-date-picker-->
<!--                            v-model="auto_audit_time"-->
<!--                            type="datetimerange"-->
<!--                            :picker-options="pickerOptions"-->
<!--                            range-separator="至"-->
<!--                            start-placeholder="开始日期"-->
<!--                            end-placeholder="结束日期"-->
<!--                            value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                            align="right">-->
<!--                    </el-date-picker>-->
<!--                </div>-->
<!--                <div class="column flex-centerall pt50" v-if="keywordempty"><div class="row flex-center pt50"><img src="../../static/img/login01.png" style="width:300px;height:300px;" /></div><div class="font10 mt15 grey9_text">暂无数据</div></div>-->
<!--                <div v-else class="row flex-start mt30 flex-wrap" >-->
<!--                    <div class="column flex-centerall pt50 w100" v-if="list.length==0&&isRes"><div class="row flex-center pt50"><img src="../../static/img/login01.png" style="width:300px;height:300px;" /></div><div class="font10 mt15 grey9_text">暂无数据</div></div>-->
<!--                    <div v-else class="white_bg mr10 mb25 p10 position_r" style="width:336px;height191px;" v-for="item in list">-->
<!--                        <div class=" position_a" style="width:215px;height:3px;left:50%;margin-left:-108px;bottom:0;" :class="active2==0?'yellow_bg':active2==1?'green_bg':'red_bg'"></div>-->
<!--                        <div class="row flex-between" style="align-items: flex-start; ">-->
<!--                            <div class="w100">-->
<!--                                <div class="row flex-center font18 fontwb yellow_bg" style="width:96px;height:33px;border:dashed 1px #a2a2a2;border:solid 1px #333;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);">{{item.car.PlateNo}}</div>-->
<!--                                <div class="font10 mt10">{{item.customer.Name}}的预约</div>-->
<!--                                <div class="font10 grey9_text">物资：{{item.spec.GoodsName}}</div>-->
<!--                                <div class="font10 grey9_text">规格：{{item.spec.Name}}</div>-->
<!--                                <div class="font18 fontwb grey9_text">{{item.purpose}}</div>-->
<!--                            </div>-->
<!--                            <div class="w100">-->
<!--                                <div class="font10">附件资料：</div>-->
<!--                                <div class="row flex-between">-->
<!--                                    <div><el-image :src="child" v-for="child in item.idcard_images" fit="fill"  :preview-src-list="item.srcList" class="mr8 mb8" style="width:46px;height:37px;border:dashed 1px #a2a2a2" ></el-image></div>-->
<!--                                    <div><el-image :src="child" v-for="child in item.license_images" fit="fill"  :preview-src-list="item.srcList"   class="mr8 mb8" style="width:46px;height:37px;border:dashed 1px #a2a2a2"></el-image></div>-->
<!--                                    <div><el-image :src="child" v-for="child in  item.car_images"  fit="fill"  :preview-src-list="item.srcList"  class="mr8 mb8" style="width:46px;height:37px;border:dashed 1px #a2a2a2" ></el-image></div>-->
<!--                                </div>-->

<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="font10 fontwb black_text">预计到达时间 {{item.end_time_text}}</div>-->
<!--                        <div class="row flex-between pt15 pb10">-->

<!--                            <div v-if="active2==0"  @click="open_refuse(item.uuid)" class="font16 row flex-center ml20 " style="left: 29px;top: 167px;width: 101.69px;height: 31px;opacity: 1;border-radius: 21px;border: 1px solid #FF5733;color:#FF5733">审批拒绝</div>-->

<!--                            <div v-if="active2==0"  @click="open(item.uuid)" class="font16 row flex-center mr30" style="left: 29px;top: 167px;width: 101.69px;height: 31px;opacity: 1;border-radius: 21px;background:#07C160;color:#fff">审批通过</div>-->
<!--                            <div v-if="active2==2" class="font10 grey9_text" >拒绝理由：{{item.refuse_reason}}</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <!--记录查询页 s-->
            <div >

                <div class="row flex-between mt15 mb25">
<!--                    <div class="row flex-start">-->
<!--                        <div class=" row flex-center font24 grey6_text cursorp" :class="recoData.currentRowId!=''?'yellow_bg':'white_bg'"  @click="onquxiantu(0)" style="width:180px;height:60px;">皮重曲线图</div>-->
<!--                        <div class=" row flex-center font24 grey6_text ml10" style="width:438px;height:60px;border: 1px solid rgba(227, 232, 238, 1);background:#f5f7f9;  ">-->
<!--                            <div class="row flex-center w100 cursorp" v-print="print">打印例表</div>-->
<!--                            <div class="row flex-center w100 cursorp" @click="exportExcel"  style="border-left: 1px solid rgba(227, 232, 238, 1);border-right: 1px solid rgba(227, 232, 238, 1);">导出例表</div>-->
<!--                            <div class="row flex-center w100 cursorp position_r">过磅照片-->

<!--                                <div class="position_ac w100 h100"><el-image src="../../static/img/yes01.svg" fit="fill"  :preview-src-list="recoData.guobangPics" class="mr8 mb8 w100 h100" style="opacity:0;"></el-image></div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="row flex-start">

                        <div class="row flex-start"><div>场地名称：</div>
                            <el-select ref="selectValue1" v-model="optionValue"
                                       @change="optionValueChange" filterable placeholder="请选择" class="mr45">
                                <el-option
                                        v-for="item in optionList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                />
                            </el-select>
                        </div>
                        <div class="row flex-start">

                            <div style="width:132px;height:36px;box-shadow: 0px 1px 4px 0px #798B95;" class="fontwb font12 row flex-center mr15 cursorp" :class="active2==0?'yellow_bg':'white_bg'" @click="onTab2(0)">待审核{{totalA}}条</div>
                            <div style="width:132px;height:36px;box-shadow: 0px 1px 4px 0px #798B95;" class="fontwb font12 row flex-center mr15 cursorp"  :class="active2==1?'green_bg':'white_bg'" @click="onTab2(1)">审核通过{{totalB}}条</div>
                            <div style="width:132px;height:36px;box-shadow: 0px 1px 4px 0px #798B95;" class="fontwb font12 row flex-center mr15 cursorp"  :class="active2==2?'red_bg':'white_bg'" @click="onTab2(2)">未通过{{totalC}}条</div>
                        </div>
                    </div>
                    <el-row>
                        <el-button type="success" plain @click="open()">审批通过</el-button>
                        <el-button type="danger" plain @click="open_refuse()">审批拒绝</el-button>
                    </el-row>
                </div>



                <template>
                    <div id="printArea">

                        <el-table v-fit-columns  v-loading = "isLoading"  element-loading-background = "rgba(255, 255, 255, .5)"  :element-loading-text = "loadText"  element-loading-spinner = "el-icon-loading"  :height="recoData.recParams.page_size==10?570:570"  :data="list"  id="ExportExcelTable"   :row-style="rowStyle"  @row-click="changeCurrentRow">
                            <el-table-column  :prop="item.name"  :label="item.label"   v-for="(item,index) in recoData.setData" :key="index" >
                            </el-table-column>
                        </el-table>

                        <div class="row flex-between">
                            <div></div>
                            <div class="row flex-start font12">
                                <el-pagination background layout="total,sizes,prev, pager, next"     :page-size="recoData.recParams.page_size"  :page-sizes="[10,20,30,40,50,100,200,500,1000,2000]" :total="recoData.total"  popper-class='select_bottom'
                                               v-model:currentPage="recoData.recParams.page" v-model:page-size="recoData.recParams.page_size"
                                               @current-change="handleCurrentChange" @size-change="handleSizeChange" style="margin: 20px 0 20px 0;" />
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <!--记录查询页 e-->
        </div>


<!--<div style="height: 200px"> </div>-->
    </section>
</template>

<script>
    import axios from "axios";
    import XLSX from 'xlsx'
    import echarts from 'echarts'
    import print from 'vue-print-nb'
    directives: {
      print
    }


    export default {
        data() {
            return {
print: {
        id: 'printArea',
        popTitle: '配置页眉标题', // 打印配置页上方的标题
        extraHead: '打印', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
        preview: true, // 是否启动预览模式，默认是false
        previewTitle: '预览的标题', // 打印预览的标题
        previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
        zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback () { console.log('正在加载预览窗口！'); console.log("that.msg", this) }, // 预览窗口打开之前的callback
        previewOpenCallback () { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
        beforeOpenCallback () { console.log('开始打印之前！') }, // 开始打印之前的callback
        openCallback () { console.log('执行打印了！') }, // 调用打印时的callback
        closeCallback () { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted () { console.log('点击v-print绑定的按钮了！') },
        // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
        // asyncUrl (reslove) {
        //   setTimeout(() => {
        //     reslove('http://localhost:8080/')
        //   }, 2000)
        // },
        standard: '',
        extarCss: ''
      },
            active:0,
            active2:0,
            active3:0,
	      week:'',// 本周周几
	      date_show:'', //本日日期
	      list:[],
	      refuse_reason:'',
	      show_refuse:false,
	      curId:'',
          checked: false,
          totalA:0,
          totalB:0,
          totalC:0,
          keywords:'',
          keywordempty:false,
          isRes:false,
          mywidth:'',

     pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        auto_audit_time: '',

        srcList: [],
	    optionList: [],
        optionValue: '',


                user: JSON.parse(window.localStorage.getItem('user')),


                isLoading:false,//表格加载
                loadText:'正在加载…请耐心等待',
                loadText1:'正在加载…请耐心等待',
                loadText2:'数据比较多正在加载…请耐心等待',

                show01:false,//曲线图弹窗
                myChart: {},
                xData: [], //横坐标
                yData: [], //y数据
                recoData:{
                    checked: false,//时间选中
                    auto_time:'',
                    WeighingUnit:'',//单位
                    curCh:'',//当前选中行的车牌号
                    guobangPics:[],//当前选中行的照片
                    currentRowId:'',//当前选中行的id
                    list:[],//表格list
                    total:0,//表格toal
                    keywords:'',
                    recParams:{
                        api:'weighingrecord',
                        methods:'get',
                        machine_code:'',
                        page_size:10,
                        page:1,
                        order:'desc',
                        data:'',
                        conditions:{Valid:1},
                        keywords:'',
                        createtime_begin_at:'',
                        createtime_end_at:'',

                    },
                    setData:[],//表格-表头数据
                    dateValue:'',
                    checkList: [],
                    sendTypeList:['采购','销售','其他','作废'],
                    dateType:'year',//年月日筛选
                    dateTypeValue:{},//毛重
                    dateTypeValue2:{},//净重
                    dateTypeValue3:{},//车次
                    zMz:'',
                    zPz:'',
                    zJz:'',
                    zKz:'',
                    zSz:'',
                }
            }
        },
 mounted: function () {
  		            this.getoptionList()
                    this.onRefresh()
  },
        methods: {
        optionValueChange(e){
                    this.onRefresh()
        },

         onRefresh() {
            this.isRes=false
            this.curId=''
            this.keywords=''
            this.keywordempty=false
            this.list=[];
            this.getList();
         },
        diyFormConfig () {
            let self=this
            let params={"machine_code":self.optionValue}
             self.$axios.get(self.baseApiUrl+'appointment/diyFormConfig',{"params": params}).then(function (res) {
                console.log("res.data 411")
                console.log(res.data.data.config)
                console.log(self.list[0])
                let resList=res.data.data.config
                            let arr = []
                           let arr2 = []
                           let one=self.list[0]
                                    for (let key in one) {
                                        if(one[key]!=null&&one[key]!=''){
                                          arr.push(one[key])
                                          arr2.push(key)
                                          }
                                          }



                            console.log("arraaaaaa")
                            console.log(arr)//值
                            console.log(arr2)//对象名
                            let abc=[]
for(let i=0;i<arr2.length;i++){
for(let j=0;j<resList.length;j++){
if(resList[j].name==arr2[i]){
abc.push(resList[j])
}
}

}
                            console.log("abc")
                            console.log(abc)//表头
                            for (var i = 0; i < abc.length; i++) {
                                if (abc[i].name =='_ch') {
                                    abc.splice(i, 1);
                                }
                            }
                            let shouwei={'label':'车号','name':'_ch'}
                            abc.unshift(shouwei);
                            self.recoData.setData=abc

             })
        },
        handleSizeChange (val) {
            this.recoData.recParams.page_size = val
            this.getRecoredList()
        },
        handleCurrentChange  (val) {
            this.recoData.recParams.page = val
            this.getRecoredList()
        },




gblxChange(e){//过磅类型筛选
console.log(e)
console.log(this.recoData.checkList)
if(e.length>0){
    this.recoData.recParams.page = 1
    this.recoData.recParams.page_size = 100
}else{
    this.recoData.recParams.page = 1
    this.recoData.recParams.page_size = 10
}
if(e.indexOf('作废')!=-1){
    console.log("有 作废")
    this.recoData.recParams.conditions.Valid=0
}else{
    this.recoData.recParams.conditions={}
}
  this.getRecoredList(e)
},






            exportExcel(){//导出表格
               let self=this;
                   this.$confirm('是否下载？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      center: true
                }).then(() => {
                    //self.recoData.recParams.page_size = 100
                    self.getRecoredList('exportExcel')
                })

            },
          exportList(list){
            console.log("exportList")
            showLoading('正在导出，请耐心等待...');
            var XLSX = require("xlsx")
              let setData = this.recoData.setData// 表格表头
                let setData2=setData.map(t => {
                    return t.Value;
                })
                let setData3=setData.map(t => {
                    return t.Key;
                })
                setData2.unshift('序号')
                let tableData = []
                tableData.push(setData2)

                                console.log("setData3.length")
                                console.log(setData3.length)
                            list.forEach ((item,index)=> {
                                let rowData = []
                                //导出内容的字段
                                rowData = [
                                    index+1,
                                    //for(let i=0;i<setData3.length;i++){
                                    //item[setData3[i]],
                                    //}
                                    item[setData3[0]],
                                    item[setData3[1]],
                                    item[setData3[2]],
                                    item[setData3[3]],
                                    item[setData3[4]],
                                    item[setData3[5]],
                                    item[setData3[6]],
                                    item[setData3[7]],
                                    item[setData3[8]],
                                    item[setData3[9]],
                                    item[setData3[10]],
                                    item[setData3[11]],
                                    item[setData3[12]],
                                    item[setData3[13]],
                                    item[setData3[14]],
                                    item[setData3[15]],
                                    item[setData3[16]],
                                    item[setData3[17]],
                                    item[setData3[18]],
                                    item[setData3[19]],
                                    item[setData3[20]],
                                    item[setData3[21]],
                                    item[setData3[22]],
                                    item[setData3[23]],
                                    item[setData3[24]],
                                    item[setData3[25]],
                                    item[setData3[26]],
                                ]
                                tableData.push(rowData)
                             })

                let ws = XLSX.utils.aoa_to_sheet(tableData)
                let wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, '例表') // 工作簿名称
                XLSX.writeFile(wb, '例表.xlsx') // 保存的文件名
                hideLoading();
            },



            changeCurrentRow(row, column, event) {
              if (this.curId== row.uuid){
              this.curId = ''
              this.recoData.guobangPics=[]
              this.recoData.Valid=''
              }else{
              this.curId = row.uuid
              this.recoData.guobangPics=row.pic_url
              this.recoData.curCh=row.Ch
              this.recoData.Valid=row.Valid
              }

            },
            rowStyle ({row, rowIndex}) {
              if (this.curId === row.uuid) {
                // 此处返回选中行的样式对象，按需设置
                return {
                  'background-color': '#e3e8ee',
                }
              }
            },








            onTab2(val){
              this.active2=val
              this.onRefresh()
            },
            onTab3(val){
              this.active3=val
              this.recoData.dateType=val==2?'week':val==1?'month':'year'
              this.get_weighing_statistics()
            },






getList(){
    let self=this;
    let params={
    status:self.active2
    }
    let params1={
    status:1
    }
    let params2={
    status:2
    }
     //const rLoading = this.openLoading();
     self.$axios.get(self.baseApiUrl+'appointment/get_appointment_list_4',{"params": params}).then(function (res) {
     let resList=res.data.data
let srcList=[]
 resList = resList.map(t => {
 t.srcList=[]

     if(t.car_images){
          t.car_images=t.car_images.split(',');
          t.srcList=t.srcList.concat(t.car_images)
     }
     if(t.idcard_images){
          t.idcard_images=t.idcard_images.split(',');
          t.srcList=t.srcList.concat(t.idcard_images)
     }
     if(t.license_images){
          t.license_images=t.license_images.split(',');
          t.srcList=t.srcList.concat(t.license_images)
     }

          return t;
        });
console.log("resList")
console.log(resList)
console.log("srcList")

     self.list=resList
     if(self.active2==0){
let resList2 =resList.filter(t=>t.status==0);
console.log("resList--0")
console.log(resList2)
     self.list=resList2
self.totalA=resList2.length
     }
        self.isRes=true



     self.$axios.get(self.baseApiUrl+'appointment/get_appointment_list_4',{"params": params1}).then(function (res) {
        self.totalB=res.data.data.length
        self.$axios.get(self.baseApiUrl+'appointment/get_appointment_list_4',{"params": params2}).then(function (res) {
            self.totalC=res.data.data.length

            self.diyFormConfig()
self.$axios.get(self.baseApiUrl+'user/getUserList').then(function (res) {
console.log("getUserList-res")
let out_user=res.data.data.out_user
out_user = out_user.map(t => {
return t.id
})
console.log(out_user)
})
      })
      })
     }).catch(error => {
      self.$message({
         message: error.message,
          type: 'warning'
      });
       //rLoading.close();
    });
},

getoptionList(){
let self=this
 let machparam={type:2}
        self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam).then(function (res) {
            console.log("get_machine_code_list-res")
            console.log(res.data.data)
            let resdata=res.data.data
            let optionList = resdata.map(t => {
            return {
               value: t.machine_code,
                label:t.remark
               }
             })
            console.log("optionList")
            console.log(optionList)
            self.optionList=optionList

                let machparam1={type:1}
                self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam1).then(function (res) {
                    console.log("get_machine_code_list-res2")
                    console.log(res.data.data)
                    let resdata2=res.data.data
                    let optionList2 = resdata2.map(t => {
                        return {
                            value: t.machine_code,
                            label:t.remark
                           }
                     })
                    self.optionList=self.optionList.concat(optionList2)
                    self.optionValue=self.optionList[0].value
                     //self.diyFormConfig()

                })

        })
        },
check_appointment(id,val){
    let self=this;
    let params={
    uuid:id,
    status:val,
    refuse_reason:self.refuse_reason?self.refuse_reason:''
    }
     this.$axios.post(this.baseApiUrl+'appointment/check_appointment',params).then(function (res) {
     console.log("res-check_appointment")
        self.$message({
            type: 'success',
            message: '提交成功!'
          });
          self.onRefresh()
     }).catch(error => {
      self.$message({
         message: error.message,
          type: 'warning'
      });
    });
},

open() {
    let self=this;
                    if(self.curId==''){
                    return;
                    }
       this.$confirm('是否确认通过审批？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
    }).then(() => {
    self.check_appointment(self.curId,1)
    }).catch(() => {
    });
},

sure_refuse() {
    let self=this;
    self.close_refuse();
    self.check_appointment(self.curId,2)
},

open_refuse() {
    let self=this;
                    if(self.curId==''){
                    return;
                    }
      this.show_refuse=true
},
close_refuse() {
    let self=this;
    this.show_refuse=false
},

// 获取当前系统日期
getdataTime(){
  let wk = new Date().getDay()
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth() + 1;
  let dd = new Date().getDate();
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  this.week = weeks[wk]
  this.date_show =  mm + "月" + dd + "日"

},
// 获取当前系统的时间
getnewTime(){
  let hh = new Date().getHours();
  let mf =
    new Date().getMinutes() < 10
      ? "0" + new Date().getMinutes()
      : new Date().getMinutes();
  let ss =
    new Date().getSeconds() < 10
      ? "0" + new Date().getSeconds()
      : new Date().getSeconds();
  this.time_show = hh + ":" + mf + ":" + ss;
},


//自动审核开启关闭
editAutoAuditConfig2(){
    let self=this;

    let params={
    is_auto_audit:self.checked?1:0,
    auto_audit_begin_time:self.auto_audit_time?self.auto_audit_time[0]:'',
    auto_audit_end_time:self.auto_audit_time?self.auto_audit_time[1]:'',
    account6_uid:''
    }

    if(self.checked){//关闭
               this.$confirm('是否确认关闭自动审核？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      center: true
                }).then(() => {

        this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
            console.log("editAutoAuditConfig2-关")
            if(res.code==1){
                self.checked=false
                self.$message({type: 'success',message: '提交成功!'});
                self.onRefresh()
            }
        })
})
    }else{//开启
      if(!self.auto_audit_time||self.auto_audit_time.length==0){
             this.$alert('请先选择时间', {
                 confirmButtonText: '确定',
            });
            return;
        }
this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
        console.log("editAutoAuditConfig2-开")
        console.log(res)
    if(res.code==1){
         self.checked=true
        self.$message({type: 'success',message: '提交成功!'});
        self.onRefresh()
        }
})


    }


},


editAutoAuditConfig(){//确定按钮
    let self=this;


if(self.keywords.length>0){
console.log("关键字搜索")
let list=self.list
let keyList=[]
    for(let i=0;i<list.length;i++){
        if(list[i].car.PlateNo.indexOf(self.keywords) != -1||list[i].spec.GoodsName.indexOf(self.keywords) != -1||list[i].customer.Name.indexOf(self.keywords) != -1){
        keyList.push(list[i])
        console.log("keyList")
        console.log(keyList)
         self.list=keyList
         self.keywordempty=false
        }else{
           self.keywordempty=true
        }
    }

}else{
this.onRefresh()
}



},

valueDateChange(){
console.log("valueDateChange")
console.log(this.auto_audit_time)
self.checked=false

},




        }


    }
</script>

<style lang="scss">
.select_bottom{
  .el-select-dropdown__item.selected{
    color:#000;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background:#fef03e;
    color:#666;
  }
}
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #fef03e;
    }
  .el-select .el-input .el-input__inner:hover{
    border-color: #fef03e;
    }
  .el-pagination.is-background .el-pager li:not(.disabled).active{background-color: #fef03e;color:#333}

  .el-pagination.is-background .el-pager li:not(.disabled):hover{background-color: #fef03e;color:#333}
</style>



// WEBPACK FOOTER //
// Main2.vue?60edde7a